import { ref } from "vue";
import { useUserStore } from "@/stores/user";
import { ForgotPasswordSchema } from "../validations/schemas";

export function useForgotPassword() {
  const userStore = useUserStore();
  const formData = ref({});
  const errors = ref({});
  const submitError = ref(null);
  const formSubmitted = ref(false);

  async function handleSubmit() {
    errors.value = {};
    submitError.value = null;

    try {
      ForgotPasswordSchema.parse(formData.value);
      const res = await userStore.requestPasswordReset(formData.value.email);

      if (res.success) {
        formSubmitted.value = true;
      } else {
        submitError.value = res.error;
      }
    } catch (formValidationError) {
      errors.value = formValidationError.errors.reduce((acc, err) => {
        acc[err.path[0]] = err.message;
        return acc;
      }, {});
    }
  }

  return {
    formData,
    errors,
    submitError,
    formSubmitted,
    handleSubmit,
  };
}
